import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  ClassTypeSelect,
  rescheduleClassesCurrentFiltersSelector,
  RESCHEDULE_CLASSES_FILTERS,
  setRescheduleFilterValue,
} from 'features/classCreation';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';

function RescheduleClassesClassTypeFilter() {
  const dispatch = useDispatch();
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };
  const { classType } = useSelector(rescheduleClassesCurrentFiltersSelector);

  const handleOnChange = useCallback(
    (option) => {
      dispatch(
        setRescheduleFilterValue({
          key: RESCHEDULE_CLASSES_FILTERS.classType,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );
  return (
    <Field
      label="Class Type"
      labelClassName="h5"
    >
      <ClassTypeSelect
        value={classType}
        placeholder="Select from dropdown"
        onChange={handleOnChange}
        styles={_styles}
      />
    </Field>
  );
}

export default RescheduleClassesClassTypeFilter;
